import React, { HTMLAttributes, PropsWithChildren } from 'react';

import './Icon.scss';

// see scripts/gg/svg/generateCommonIconNameType.ts
// note that filenames are converted to lowercase by the build process
// AUTO-GENERATED-TYPE START
export type CommonIconName =
    | '24-hour'
    | 'accessory-listing'
    | 'accessory-priority-listing'
    | 'alarm-clock'
    | 'alarm-clock-checked'
    | 'alarm-clock-disabled'
    | 'analysis'
    | 'analysis2'
    | 'analytics'
    | 'application'
    | 'apply'
    | 'arrow'
    | 'arrow-accordion'
    | 'arrow-bold'
    | 'arrow-menu'
    | 'arrow-nav'
    | 'arrow-right'
    | 'arrow-slide'
    | 'arrow-test'
    | 'arrow-thin'
    | 'bell'
    | 'book-appointment'
    | 'bookmark'
    | 'bulb'
    | 'calendar'
    | 'calendar-solid'
    | 'calendarinvert'
    | 'callsign'
    | 'card-checklist'
    | 'card-image'
    | 'card-text'
    | 'category'
    | 'check'
    | 'check-shield'
    | 'check2'
    | 'checkbox'
    | 'checklist'
    | 'checklist-thin'
    | 'checkmark'
    | 'checkmark-circle'
    | 'chevron'
    | 'choice'
    | 'clipboard'
    | 'clock-history'
    | 'close'
    | 'close-borderless'
    | 'close-light'
    | 'close2'
    | 'close3'
    | 'cloud-arrow-up'
    | 'cloud-plus'
    | 'collection-list'
    | 'collection-list-filled'
    | 'color-info'
    | 'color-painting-palette'
    | 'color-palette-sample'
    | 'compare'
    | 'consultant'
    | 'consultant-portal-briefcase'
    | 'consultant-portal-consultant-faq'
    | 'consultant-portal-consultant-inquiry'
    | 'consultant-portal-customer-add'
    | 'consultant-portal-customer-search'
    | 'consultant-portal-digital-training'
    | 'consultant-portal-documentation'
    | 'consultant-portal-dropdown-arrow'
    | 'consultant-portal-edit-data'
    | 'consultant-portal-eye'
    | 'consultant-portal-eye-closed'
    | 'consultant-portal-gift'
    | 'consultant-portal-graph'
    | 'consultant-portal-help'
    | 'consultant-portal-hidden-in-navigation'
    | 'consultant-portal-individual-training'
    | 'consultant-portal-laptop'
    | 'consultant-portal-lines-total'
    | 'consultant-portal-logout'
    | 'consultant-portal-megaphone'
    | 'consultant-portal-messages'
    | 'consultant-portal-messages2'
    | 'consultant-portal-more'
    | 'consultant-portal-no-messages'
    | 'consultant-portal-notification'
    | 'consultant-portal-order'
    | 'consultant-portal-profile'
    | 'consultant-portal-regional'
    | 'consultant-portal-send'
    | 'consultant-portal-share'
    | 'consultant-portal-table-arrow'
    | 'consultant-portal-training'
    | 'consultant-portal-voucher'
    | 'controls'
    | 'copy'
    | 'data-thin'
    | 'delivery'
    | 'discount'
    | 'document'
    | 'dosage'
    | 'download'
    | 'drag'
    | 'drag-and-drop'
    | 'dropdown-arrow'
    | 'dust-bin'
    | 'edit'
    | 'edit-pencil'
    | 'edit-pencil2'
    | 'elasticity'
    | 'envelope'
    | 'extra-tipp'
    | 'eye'
    | 'eye-strikethrough'
    | 'facebook'
    | 'feedback-quote'
    | 'feedback-shape-left'
    | 'feedback-shape-right'
    | 'filter'
    | 'frame'
    | 'fullscreen'
    | 'gear'
    | 'gift-light'
    | 'gift-solid'
    | 'graph-stats'
    | 'grid-view'
    | 'grid-view2'
    | 'hand'
    | 'heart-light'
    | 'heart-solid'
    | 'heart-thin'
    | 'help'
    | 'help2'
    | 'hint'
    | 'hint2'
    | 'home'
    | 'image'
    | 'info'
    | 'info2'
    | 'info3'
    | 'information-circle'
    | 'ingredients'
    | 'instagram'
    | 'instruction'
    | 'intro'
    | 'label'
    | 'layer-forward'
    | 'layer-one'
    | 'layer-two'
    | 'list-consultant'
    | 'location'
    | 'lock'
    | 'logout'
    | 'lotion-settings'
    | 'mail'
    | 'mail-filled'
    | 'make-up'
    | 'make-up-warning'
    | 'manual'
    | 'map-pin'
    | 'megaphone'
    | 'megaphone2'
    | 'message'
    | 'message-thin'
    | 'minus'
    | 'moisture'
    | 'more'
    | 'neutralize'
    | 'no-product-cart'
    | 'notes'
    | 'notice'
    | 'notification'
    | 'online-edit'
    | 'online-meeting'
    | 'opacity'
    | 'opacity-info'
    | 'open-book'
    | 'open-letter'
    | 'package'
    | 'package-basic-equipment'
    | 'package-fast'
    | 'paper-write'
    | 'phone'
    | 'pin'
    | 'play'
    | 'play2'
    | 'plus'
    | 'plus2'
    | 'plus3'
    | 'pricelist'
    | 'primer'
    | 'primer-face'
    | 'primer-info'
    | 'primer-strikethrough'
    | 'priority-high'
    | 'priority-low'
    | 'priority-medium'
    | 'product-description'
    | 'product-select'
    | 'products'
    | 'put-on'
    | 'question-help-message'
    | 'question-mark'
    | 'question-mark-filled'
    | 'quote'
    | 'rating'
    | 'read'
    | 'read-checkmark'
    | 'recommendations'
    | 'remove'
    | 'repeat'
    | 'reply'
    | 'save'
    | 'screen-reader-off'
    | 'screen-reader-on'
    | 'search'
    | 'secure-lock'
    | 'secure-lock-circle'
    | 'semicolon'
    | 'send-mail'
    | 'settings'
    | 'share'
    | 'shop-external'
    | 'shopping-cart-empty'
    | 'shopping-cart-empty-thin'
    | 'shopping-cart-full'
    | 'single-neutral'
    | 'skin-tone'
    | 'social-like'
    | 'speech'
    | 'star'
    | 'star-solid'
    | 'tick'
    | 'tipp'
    | 'tracking'
    | 'training-mode'
    | 'trash'
    | 'trash2'
    | 'truck'
    | 'truck-clock'
    | 'undo'
    | 'usage-body'
    | 'usage-eyes'
    | 'usage-face'
    | 'usage-lips'
    | 'usage-neck'
    | 'user'
    | 'user-add'
    | 'user-focus'
    | 'user-overview'
    | 'user-question'
    | 'users'
    | 'users-home'
    | 'vegan'
    | 'video'
    | 'voucher'
    | 'voucher-filled'
    | 'warning'
    | 'whatsapp'
    | 'youtube';
// AUTO-GENERATED-TYPE END

export const Icon: React.FunctionComponent<PropsWithChildren<HTMLAttributes<SVGElement> & { icon: CommonIconName }>> = (
    props,
) => {
    const href = '/_Resources/Static/Packages/GesagtGetan.Theme/Assets/Sprite.svg#icon-' + props.icon;
    const className = ['icon', 'icon--' + props.icon, props.className].join(' ');

    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
            className={className}
        >
            <use xlinkHref={href} href={href} />
        </svg>
    );
};
